// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__M2WV4","wrapperMinimal":"Team_wrapperMinimal__apc8N","loadingContainer":"Team_loadingContainer__BuZOj","loadingText":"Team_loadingText__iQIXl"};